<template>
	<div>
		<v-card flat>
			<v-card-text>
				<brace
					style="height:90vh;"
					class="kbet-editor"
					:mode="'json'"
					@code-change="onEditorCodeChange"
					@setHandler="
						h => {
							editorHandler = h;
						}
					"
				/>
			</v-card-text>
		</v-card>
		<v-btn
			v-if="
				dataProp.renderMode != 'parsed' &&
					(selectedFile.extension == 'pdf' ||
						/xl/gi.test(selectedFile.extension))
			"
			color="blue darken-1"
			small
			absolute
			top
			right
			fab
			@click="jsonToText"
		>
			<v-icon>{{ textMode ? 'code' : 'text_fields' }}</v-icon>
		</v-btn>
	</div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
export default {
	components: {},
	data() {
		return {
			editorHandler: false,
			displayJSON: false,
			textMode: true,
			originalFileData: [],
		};
	},
	created() {
		// console.log(this.dataProp)
		this.getFileJSON({
			renderMode: this.dataProp.renderMode,
			filePathURL: '?uuid=' + this.selectedFile.filename.split('.')[0],
		}).then(data => {
			this.originalFileData = data;
			this.editorHandler.setValue(JSON.stringify(data, null, 2));
			// this.displayJSON = JSON.stringify(data, null, 2);
		});
	},
	methods: {
		...mapMutations(['openSnackbar']),
		// ...mapMutations("rejectedMeta", ["closeFileMetaDialog"]),
		...mapActions('rejectedMeta', ['getFileJSON']),
		onEditorCodeChange(code) {
			this.editorCode = code;
			// console.log(code);
		},
		jsonToText() {
			if (this.jsonValidate(this.editorCode)) {
				if (!this.textMode) {
					let transformedFileData = JSON.parse(
						JSON.stringify(this.originalFileData)
					);
					let textArray = [];
					for (let i of transformedFileData) {
						for (let j of i) {
							textArray.push(j.str);
						}
					}
					this.editorHandler.setValue(JSON.stringify(textArray, null, 2));
				} else {
					this.editorHandler.setValue(
						JSON.stringify(this.originalFileData, null, 2)
					);
				}
				this.textMode = !this.textMode;
			} else {
				this.openSnackbar({
					text: 'Invalid JSON please fix the error',
				});
			}
		},
		jsonValidate(json) {
			try {
				var j = JSON.parse(json);
				return true;
			} catch (err) {
				return false;
			}
		},
	},
	computed: {
		...mapGetters('rejectedMeta', ['selectedFile']),
	},
	mounted() {},
	props: ['dataProp'],
};
</script>

<style lang="scss" scoped>
.v-card__text {
	padding: 0px;
}
</style>
